export default __webpack_public_path__ + "static/media/yuman3.33a5b575.png";